import { render, staticRenderFns } from "./TheFollowerCardB.vue?vue&type=template&id=8189efdc"
import script from "./TheFollowerCardB.vue?vue&type=script&lang=js"
export * from "./TheFollowerCardB.vue?vue&type=script&lang=js"
import style0 from "./TheFollowerCardB.vue?vue&type=style&index=0&id=8189efdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports